module.exports = "https://cdn.littlereply.com/tt/resource/right-icon.adf41c4b79899340813c85efe271924e.png";